angular.module('unergie.main')
.controller('addrModalCtrl', ($scope, $uibModalInstance, ApiUser, ReferencesService, obj, type, AlertManager, ErrorCatcher, BoFeaturesService, DataAccess) => {
    $scope.freeAddrModif = BoFeaturesService.isFeatureOn('freeAddrModif')
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    $scope.canSeeModifyPrmAddrMessage = feats.canSeeModifyPrmAddrMessage

    $scope.adminMode = false
    $scope.chosenAddr = undefined
    $scope.obj = obj
    $scope.type = type

    let addressModified = false

    $scope.toggleAdminMode = function () {
        $scope.adminMode = !$scope.adminMode
        if ($scope.adminMode) {
            let actual = false
            if (obj.actual_addr_post_code) {
                actual = true
            }
            $scope.chosenAddr = {
                addr_city_code: actual ? obj.actual_addr_city_code : obj.addr_city_code,
                addr_num_street: actual ? obj.actual_addr_num_street : obj.addr_num_street,
                addr_city_lbl: actual ? obj.actual_addr_city_lbl : obj.addr_city_lbl,
                addr_post_code: actual ? obj.actual_addr_post_code : obj.addr_post_code,
                addr_bat: actual ? obj.actual_addr_bat : obj.addr_bat,
                addr_details: actual ? obj.actual_addr_details : obj.addr_details,
                addr_locality: actual ? obj.actual_addr_locality : obj.addr_locality,
            }
        } else {
            $scope.chosenAddr = undefined
        }
    }


    $scope.selectCity = function (commune) {
        if (commune) {
            $scope.chosenAddr.addr_city_lbl = commune.township
            $scope.chosenAddr.addr_post_code = commune.postcode
            $scope.chosenAddr.addr_city_code = commune.insee_code
        }
    }


    ReferencesService.getRef('inseepostcode', true).then((mapping) => {
        $scope.codes = mapping
    })

    // LOOKUP
    $scope.lookupAddr = function (addr) {
        $scope.coordinates = undefined
        $scope.searching = true
        const p = ApiUser.lookupStrictAddr({ q: addr }).$promise
        p.then(() => {
            $scope.searching = false
        }).catch(() => {
            $scope.searching = false
        })
        return p
    }


    $scope.updateAddress = function (data) {
        $scope.chosenAddr = data
        $scope.coordinates = { x: data.addr_x, y: data.addr_y }
    }


    $scope.updatedAddr = function () {
        const newAddr = $scope.chosenAddr
        delete newAddr.addr_x
        delete newAddr.addr_y
        delete newAddr.label
        if (!newAddr.addr_bat) {
            newAddr.addr_bat = null
        }
        if (!newAddr.addr_details) {
            newAddr.addr_details = null
        }
        if (!newAddr.addr_locality) {
            newAddr.addr_locality = null
        }
        $scope.modifying = true
        if ($scope.type === 'billingAccount') {
            return ApiUser.updateBillingAddr({ id_account: $scope.obj.id_account, force: $scope.adminMode }, newAddr).$promise
            .then(() => {
                AlertManager.success('Adresse de facturation modifiée')
                addressModified = newAddr
            }).catch(ErrorCatcher)
            .finally(() => {
                $scope.modifying = false
            })
        }
        return DataAccess.updatePrmAddress({ id: $scope.obj.id }, newAddr).$promise.then(() => {
            AlertManager.success('Adresse de distribution modifiée')
            addressModified = newAddr
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.modifying = false
        })
    }

    $scope.resetAddr = function () {
        if ($scope.type === 'prm') {
            return DataAccess.updatePrmAddress({ id: $scope.obj.id }, {}).$promise.then(() => {
                AlertManager.success('Adresse de distribution rétablie')
                addressModified = 'Reset adresse du PRM'
            }).catch(ErrorCatcher)
            .finally(() => {
                $scope.modifying = false
            })
        }
    }

    // RETURN OK
    $scope.ok = () => $uibModalInstance.close(addressModified)

    $uibModalInstance.dismiss = $scope.ok
})
